import { effect, EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { LanguageFacade } from '@core/language/facades/language.facade';
import { UserInfoFacade } from '@core/user-info/facades/user-info.facade';
import { setDateDefaults } from '@kaseya-utils';

export function provideDateDefaults(): EnvironmentProviders {
  return provideAppInitializer(() => {
    const userInfoFacade = inject(UserInfoFacade);
    const languageFacade = inject(LanguageFacade);

    effect(() => setDateDefaults({ timeZone: userInfoFacade.userTimeZoneId(), locale: languageFacade.language() }));
  });
}
